module.exports = __webpack_public_path__ + "img/BG_header_machines_infos.22c4d748.jpg";